<script>
import {Link} from '@inertiajs/inertia-vue3'
import useLinkInterceptor from '@/shared/useLinkInterceptor'

export default {
    components: {
        Link
    },
    props: {
        as: {
            type: String,
            default: 'a',
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        href: {
            type: String,
        },
        method: {
            type: String,
            default: 'get',
        },
        replace: {
            type: Boolean,
            default: false,
        },
        preserveScroll: {
            type: Boolean,
            default: false,
        },
        preserveState: {
            type: Boolean,
            default: null,
        },
        only: {
            type: Array,
            default: () => [],
        },
        headers: {
            type: Object,
            default: () => ({}),
        },
        queryStringArrayFormat: {
            type: String,
            default: 'brackets',
        },
    },
    methods: {
        intercept: () => {
            const interceptor = useLinkInterceptor()

            if (! interceptor.intercept.value) {
                return true
            }

            return confirm(interceptor.interceptMessage.value)
        }
    }
}
</script>

<template>
    <!-- eslint-disable -->
    <Link
        :as="as"
        :data="data"
        :href="href"
        :method="method"
        :replace="replace"
        :preserve-scroll="preserveScroll"
        :preserve-state="preserveState"
        :only="only"
        :headers="headers"
        :query-string-array-format="queryStringArrayFormat"
        :onBefore="intercept"
    >
        <slot />
    </Link>
    <!-- eslint-enable -->
</template>